import { useState, useEffect } from 'react';
import OrdemServicoController from '../controllers/OrdemServicoController';
import { OrdemServicoAtualizar } from '../routes/RoutesNames';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


interface Maquina {
    prod_descricao: string;
    ordemServicos: OrdemServico;
}
interface OrdemServico {
    OS_id: number;
    dataInclusao: Date;
    dataEntrega: Date;
    OS_status: string;
    nomeResponsavel: string;
}

const useMaquinaConsultar = (MaquinaId?: number) => {
    const [single, setSingle] = useState<Maquina>();
    const navigate = useNavigate();
    const [values, setValues] = useState({
        prod_descricao: single?.prod_descricao || '',
        ordemServico: single?.ordemServicos || [],
    });

    const handleSearchOrdemServico = async () => {
        if (!MaquinaId) return;

        const ordemServicosMaquina = await OrdemServicoController.ListarOrdemServicoMaquina(MaquinaId);
        //console.log('ordem servico maquina: ', ordemServicosMaquina);

        if (ordemServicosMaquina.StatusCode === 200 && ordemServicosMaquina.Data) {
            console.log('odem servico maquina --->: ', ordemServicosMaquina.Data);
            // Todos os objetos tem o mesmo prod_descricao, pega do primeiro
            const descricao = ordemServicosMaquina.Data[0].prod_descricao;
            // Remove prod_descricao de cada item para o DataTable
            const ordens = ordemServicosMaquina.Data.map(({ prod_descricao, ...rest }: any) => ({
                ...rest,
                dataInclusao: new Date(rest.dataInclusao).toLocaleDateString('pt-BR'),
                dataEntrega: new Date(rest.dataEntrega).toLocaleDateString('pt-BR'),
            }));

            setValues({
                prod_descricao: descricao,
                ordemServico: ordens,
            });
        }
        else{
            toast.error('Nenhuma ordem de serviço para essa máquina.');
        }
    };

    useEffect(() => {
        handleSearchOrdemServico();
    }, [MaquinaId]);

    const handleNavigate = async (OS_id: number): Promise<void> => {
        // Exemplo: passa o ID da OS para outra tela
        //navigate(`/maquina/consultar/${params.row.id}`);
        navigate(OrdemServicoAtualizar.replace(':id', OS_id.toString() ?? ''));
        console.log(OS_id);
    }

    return {
        handleNavigate,
        values,
    }
};

export default useMaquinaConsultar;
